export default "__VITE_ASSET__Cd0kSVMO__"